export interface IStaffUrlParams {
  position: string;
  positionIds: number[] | string;
  filterBy: string;
  period: string;
  filterItems: Array<{ value: string | number; label: string }>;
  employeeIds?: string;
}

export const openStaffEmployeeWindow = ({
  position,
  positionIds,
  filterBy,
  period,
  filterItems,
  employeeIds,
}: IStaffUrlParams) => {
  const params = new URLSearchParams();

  params.append("position", position);

  const posIdsString = Array.isArray(positionIds)
    ? `[${positionIds.join(",")}]`
    : positionIds;
  params.append("positionId", posIdsString);

  params.append("filterBy", filterBy);
  params.append("period", period);

  if (employeeIds) {
    params.append("employeeIds", employeeIds);
  }

  filterItems.forEach((el, index) => {
    params.append(`filterItems[${index}][value]`, String(el.value));
    params.append(`filterItems[${index}][label]`, el.label);
  });

  const finalUrl = `/staff/employee?${params.toString()}`;
  window.open(finalUrl, "_blank");
};
